import * as account from '../services/api/account';

import { SubmissionError } from 'redux-form';

export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';

export function register(accountParams) {

    return dispatch => {
        return account
            .register(accountParams)
            .then(() => dispatch(userRegistered({ first_name: accountParams.first_name })))
            .catch((res) => {
                throw new SubmissionError({
                    ...res.payload,
                    _error: res.payload
                });
            });
    }
}

export function userRegistered(registrant) {
    return {
        type: REGISTRATION_SUCCESS,
        registrant
    }
}